import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Heading } from '../Heading'
import { HomepageQuiz } from '../HomepageQuiz'
import { QuizOnlyOnceHeading } from './QuizOnlyOnceHeading'

export const QuizOnlyOnce = () => {
  const { ctaNextPage } = useStaticData<{ ctaNextPage?: string }>()

  const isQuizCompleted = !!ctaNextPage

  if (!isQuizCompleted) return <HeroQuizComponents />

  return <QuizOnlyOnceHeading />
}

const HeroQuizComponents = () => {
  const { t } = useTranslation('@mc/next')
  return (
    <>
      <Heading />
      <div className='row no-gutters'>
        <div className='col-12 col-lg-10'>
          <div className='mc-text-h5'>{t('home.hero.quiz.title')}</div>
          <HomepageQuiz />
        </div>
      </div>
    </>
  )
}
